import { isServer } from 'acq-utils/lib/misc';

export const isUS = () =>
  isServer() ? false : RegExp(/\/(en-)?us\//).test(window.location.href);
